export default {
  data: function data() {
    return {};
  },
  props: {
    url: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
};